<template>
  <ActionItem
    :disabled="disabled"
    label="View In App"
    icon="mdi-map"
    @click.native="launchCustomerSite()" />
</template>

<script>
import ActionItem from '@/components/general/ActionItem.vue'
import { mapState, mapGetters } from "vuex"
import Auth from "@/services/Auth.js"
import { Logger } from "aws-amplify"
const logger = new Logger("ACTIONS MENU")

export default {
  components: { ActionItem },

  props: {
    org: {
      type: [String, Boolean],
      default: () => ''
    },

    device: {
      type: [String, null],
      default: () => false
    },

    vehicle: {
      type: Object,
      requried: false,
      default: () => false
    },

    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  computed: {
     ...mapState (['goToken', 'driverHoursProviderName', 'telematicsProviderName', 'driverHoursProviderUrl', 'telematicsProviderUrl', 'DashBoardUserId']),
    ...mapGetters('presence', [
      'vehicleStatus', 'devicesMap'
    ]),
  },

  methods: {
    async launchCustomerSite() {
      logger.debug("show on map", this.device)
      
      let vehicle_id = false
      try {
        if(!this.vehicle) {
          vehicle_id = this.devicesMap[this.device].vehicle_id
        } else {
          vehicle_id = this.vehicle.id
        }
        

      } catch (err) {
        logger.debug("could not find vehicle id", this.device, this.devicesMap)
        return 
      }

      let dataToSend = {
        orgID: this.org,
        vehicle_id: vehicle_id
      }

      logger.debug("HERE!")

      // if we have a go token, we need to pass over all the data the customer site might expect from the GoPortal
      if(this.goToken) {
        const session = await Auth.currentSession()
        dataToSend.camtoken = session.refreshToken
        dataToSend.gotoken = this.goToken
        dataToSend.driverHoursProviderName = this.driverHoursProviderName
        dataToSend.telematicsProviderName = this.telematicsProviderName
        dataToSend.driverHoursProviderUrl = this.driverHoursProviderUrl
        dataToSend.telematicsProviderUrl = this.telematicsProviderUrl
        dataToSend.DashBoardUserId = this.DashBoardUserId
        dataToSend.gouser = true
      }

      let newTab = window.open(location.protocol + "//" + process.env.VUE_APP_user_domain + "/map-view", '_blank')
      newTab.name = JSON.stringify(dataToSend)
    },
  }
  
}
</script>